// extracted by mini-css-extract-plugin
export default {"fade":"nsvdXVtotrCSaBzfcrsp","scrollLink":"lFYIO0ioJlSYa1igfTph","wrapper":"Ift2AruCQ6M5H4i4gCOa"};